module.exports = __webpack_public_path__ + "img/IMG_2495.bbe18aab.jpg";